import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=c8458c38&scoped=true&"
import script from "./MainPage.ts?vue&type=script&lang=ts&"
export * from "./MainPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8458c38",
  null
  
)

export default component.exports
import {QToolbar,QTabs,QTab,QBadge,QInput,QIcon,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QTabs,QTab,QBadge,QInput,QIcon,QTabPanels,QTabPanel})
